import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointCrn = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };

  return (
    <>
          {context.state['Carriere'+ClientConjoint].filter((Carriere) => Carriere.Nature === "Crn").length > 0 && (
            <>
        <tr>
          <td>CRN section B</td>
          <td>
            <TextField
              value={context.state["TableauPoints" + ClientConjoint].RetraiteCompCrnSectionB}
              onChange={(e)=>{context.handlePointRetraite(ClientConjoint,"RetraiteCompCrnSectionB",e)}}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              small
            />
          </td>
          <td>
            <DropDown
              value={context.state["TableauPoints" + ClientConjoint].AnneeFinCrnSectionB}
              onChange={(e)=>{
                context.handlePointRetraite(ClientConjoint,"AnneeFinCrnSectionB",e)
                props.CalculRetraite();
              }}
              options={[
                { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
              ]}
              small
            />
          </td>
          <td>
            <TextField
              value={resultRetraite?.InfosRetraite?.Crn?.General?.PointCalculeSectionB === undefined ? 0 : resultRetraite?.InfosRetraite?.Crn?.General?.PointCalculeSectionB}
              disabled={true}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              small
            />
          </td>
        </tr>
        <tr>
          <td>CRN section C</td>
          <td>
            <TextField
              value={context.state["TableauPoints" + ClientConjoint].RetraiteCompCrnSectionC}
              onChange={(e)=>{context.handlePointRetraite(ClientConjoint,"RetraiteCompCrnSectionC",e)}}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              small
            />
          </td>
          <td>
            <DropDown
              value={context.state["TableauPoints" + ClientConjoint].AnneeFinCrnSectionC}
              onChange={(e)=>{
                context.handlePointRetraite(ClientConjoint,"AnneeFinCrnSectionB",e)
                props.CalculRetraite();
              }}
              options={[
                { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
              ]}
              small
            />
          </td>
          <td>
            <TextField
              value={resultRetraite?.InfosRetraite?.Crn?.General?.PointCalculeSectionC === undefined ? 0 : resultRetraite?.InfosRetraite?.Crn?.General?.PointCalculeSectionC}
              disabled={true}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              small
            />
          </td>
        </tr>
        </>
      )}
    </>
  );
};
export default PointCrn;
